export const and = (...fns) => (...args) => fns.every((fn) => fn(...args));

export const or = (...fns) => (...args) => fns.some((fn) => fn(...args));
